import unescape from 'lodash/unescape';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import IconParking from '@spothero/icons/parking';
import Image from 'common/image/Image';
import StarRating from 'common/star-rating/StarRating';
import withConfig from 'config/withConfig';

const AirportFacilityDetails = ({
    facility: {
        id,
        title,
        street_address: address,
        city,
        state,
        rating_info: ratingInfo,
        logos,
        images,
        spotType,
    },
    isAdmin,
    hideAdminLink,
    showSpotType,
    onFacilityClick,
    staticBaseUrl,
}) => {
    const logoId =
        logos && logos.length > 0
            ? logos[0].id
            : images && images.length > 0
            ? images[0].id
            : null;
    const imageProps = {
        width: 144,
        height: 144,
        alt: `Photo of ${title}`,
        ...(logoId
            ? {cloudinaryImageId: logoId}
            : {src: `${staticBaseUrl}img/missing-image.png`}),
    };

    return (
        <div className="AirportFacilityDetails">
            <div
                className="AirportFacilityDetails-logo"
                onClick={onFacilityClick}
            >
                <Image {...imageProps} />
            </div>
            <div className="AirportFacilityDetails-content">
                <h2 itemProp="name" onClick={onFacilityClick}>
                    {unescape(title)}
                </h2>
                {Boolean(address && city && state) && (
                    <h3 onClick={onFacilityClick}>
                        {address} {city}, {state}
                    </h3>
                )}
                {ratingInfo && ratingInfo.number_of_ratings > 9 && (
                    <div className="AirportFacilityDetails-ratings">
                        <StarRating stars={ratingInfo.star_rating} />{' '}
                        <span
                            itemProp="aggregateRating"
                            itemScope
                            itemType="http://schema.org/AggregateRating"
                        >
                            <meta
                                itemProp="ratingValue"
                                content={ratingInfo.star_rating}
                            />
                            (
                            <span itemProp="reviewCount">
                                {ratingInfo.number_of_ratings}
                            </span>{' '}
                            Reviews)
                        </span>
                    </div>
                )}
                {showSpotType && spotType && (
                    <div className="AirportFacilityDetails-type">
                        <IconParking />
                        {spotType}
                    </div>
                )}
                {isAdmin && !hideAdminLink && (
                    <div className="AirportFacilityDetails-facility-link">
                        <a
                            className="AirportFacilityDetails-admin-link"
                            href={`/admin/spots/${id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Facility Admin Page
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

AirportFacilityDetails.propTypes = {
    facility: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
    hideAdminLink: PropTypes.bool,
    showSpotType: PropTypes.bool,
    onFacilityClick: PropTypes.func,
    staticBaseUrl: PropTypes.string,
};

AirportFacilityDetails.defaultProps = {
    hideAdminLink: false,
};

const mapStateToProps = state => {
    const {
        user: {
            data: {isAdmin},
        },
    } = state;

    return {
        isAdmin,
    };
};

const enhance = compose(
    withConfig(['staticBaseUrl']),
    connect(mapStateToProps)
);

export default enhance(AirportFacilityDetails);
